import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LoadingScreenComponent implements OnInit, OnDestroy {
  private loadingService = inject(LoadingService);

  @Input() local?: boolean;
  @Input() contrast?: boolean;

  public ngOnInit() {
    if (!this.local) {
      this.loadingService.isLoading$.next(true);
    }
  }

  public ngOnDestroy(): void {
    if (!this.local) {
      this.loadingService.isLoading$.next(false);
    }
  }
}
